<template>
  <el-card class="theme-block">
    <div slot="header" v-if="title">
      <span>{{ title }}</span>
    </div>
    <el-form
      :element-loading-text="$t('themeViewFormLoadingText')"
      :model="data"
      @submit.native.prevent="submit"
      enctype="multipart/form-data"
      id="uploadform"
      label-position="left"
      ref="data"
      v-loading="loading"
    >
      <el-form-item
        :data-qa="`Content-ThemeForm-Item-${id}`"
        :key="id"
        :label-width="labelWidth"
        :label="$t(item.label)"
        v-for="(item, id) in data.file"
        v-if="data.file"
      >
        <div class="image-block">
          <img @error="whenImageNotFound(id)" :src="item.currentImgSrc" height="34" v-show="item.currentImgSrc || !item.isLocal" />
          <input
            :class="item.class"
            :data-qa="`Content-ThemeForm-Upload-${id}`"
            :id="item.name"
            :name="item.name"
            @change="onFileChange(id, $event)"
            accept="image/*"
            class="input-file"
            type="file"
            v-if="item.isLocal"
            v-validate="item.validate"
          >
          <label :for="item.name" class="el-button el-button--default" v-if="item.isLocal">{{ $t('themeViewButtonUploadImageText') }}</label>
          <div class="selected-file-name" v-if="item.isLocal">{{ item.selectedFileName || $t('NoFileChosen') }}</div>
          <el-button
            :data-qa="`Content-ThemeForm-Button-${id}`"
            @click="removeImage(id)"
            v-show="!item.isLocal"
          >
            {{ $t('themeViewButtonRemoveImageText') }}
          </el-button>
          <input type="hidden" :name="'remove_' + id" :value="item.isLocal ? id : ''" />
        </div>
        <div class="help is-danger" v-if="errors.has(item.name)">
          {{ errors.first(item.name) }}
        </div>
        <div :data-qa="`Content-ThemeForm-Description-${id}`" class="column-describe" v-if="item.description">
          <i>{{ $t(item.description) }}</i>
        </div>
      </el-form-item>
      <el-form-item
        :data-qa="`Content-ThemeForm-Item-${id}`"
        :error="errors.has(id) ? errors.first(id) : ''"
        :key="id"
        :label="$t(item.label)"
        :label-width="labelWidth"
        :show-message="errors.has(id)"
        v-for="(item, id) in data.text"
      >
        <el-input
          :auto-complete="isPassword(item.type) ? 'new-password' : 'off'"
          :data-qa="`Content-ThemeForm-Input-${id}`"
          :id="id"
          :name="id"
          :data-vv-as="$t(item.label)"
          :placeholder="$t(item.placeholder) || ''"
          clearable
          :type="item.type"
          v-if="isText(item.type) || isPassword(item.type)"
          v-model="item.model"
          v-validate="item.validate"
          :data-vv-validate-on="isPassword(item.type) ? 'change' : 'input|blur'"
        />
        <el-input
          :data-qa="`Content-ThemeForm-Input-${id}`"
          :id="id"
          :name="id"
          :data-vv-as="$t(item.label)"
          :placeholder="$t(item.placeholder) || ''"
          clearable
          :type="item.type"
          v-if="isNumber(item.type)"
          v-model.number="item.model"
          v-validate="item.validate"
        />
        <el-color-picker
          :data-qa="`Content-ThemeForm-ColorPicker-${id}`"
          :data-vv-as="$t(item.label)"
          :id="id"
          :name="id"
          :placeholder="$t(item.placeholder)"
          :popper-class="item.class"
          v-if="isColorPicker(item.type)"
          v-model="item.model"
          v-validate="item.validate"
        ></el-color-picker>
        <input :name="id" type="hidden" v-if="isColorPicker(item.type)" v-model="item.model" />
        <el-input
          :class="item.class"
          :data-qa="`Content-ThemeForm-Textarea-${id}`"
          :id="id"
          :name="id"
          :placeholder="$t(item.placeholder) || ''"
          :rows="20"
          type="textarea"
          v-if="isTextarea(item.type)"
          v-model="item.model"
          v-validate="item.validate"
        />
        <div :data-qa="`Content-ThemeForm-Description-${id}`" class="column-describe" v-if="item.description">
          <i>{{ $t(item.description) }}</i>
        </div>
      </el-form-item>
      <el-form-item class="btn-display-end" size="large">
        <el-button
          :disabled="saving || errors.any()"
          :loading="saving"
          data-qa="Content-ThemeForm-Button-Save"
          native-type="submit"
          type="warning"
        >
          {{ $t('themeViewButtonSaveText') }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import main from './ThemeView.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './ThemeView.scss'
</style>



// WEBPACK FOOTER //
// ThemeView.vue?8a559ef8